/**
 * This object stores all the information needed to regester and unregister
 * an event listener (aka event handler) using prototype's Event.observe
 * or Event.stopObserving.  Convenience funtions are also provided to
 * actually call observe and stopObserving using a single object or array of
 * objects.
 *
 * It is useful to store the listener information in an object because
 * unregistering a listener requires using the exact same parameters as
 * when the listener was originally registered.
 */

'use strict';

var ListenerInfo = function (element, eventName, observer, useCapture) {
    this.initialize(element, eventName, observer, useCapture);
};

ListenerInfo.prototype = {
    //element to attach the listener to or its ID
    element: null,
    //The name of the event to listen for, such as "click" or "hover"
    eventName: null,
    //The function to call when the event is triggered
    observer: null,
    //boolean, fire info when sinking down (true) or bubbling up (false)
    //(doesn't apply on IE, which is always up)
    useCapture: false,

    initialize: function(element, eventName, observer, useCapture) {
        this.element = element;
        this.eventName = eventName;
        this.observer = observer;

        if (typeof useCapture != 'undefined') {
            this.useCapture = useCapture;
        }
    }
};

module.exports = ListenerInfo;


//////////////////
// WEBPACK FOOTER
// ./mits/Events/ListenerInfo.js
// module id = 11
// module chunks = 0